export interface IByUser {
  uid: string;
  title?: string;
}
